const IS_USING_POINTER_CLASS = 'is-using-pointer'

/**
 * A utility function that listens for keyboard and mouse events on the HTML
 * body, then sets a `is-using-pointer` class if the user is using such kind of
 * pointer (such as a mouse or finger to tap). The app can then use that class
 * to alter its behaviour, such as to only show focus indicator on links and
 * buttons when the user is navigating via keyboard.
 */

export default function detectPointer() {
  if (document.body.classList) {
    document.body.addEventListener('keydown', track)
    document.body.addEventListener('mousedown', track)

    let isUsingPointer = false

    function track({ type }) {
      isUsingPointer = type === 'mousedown'
      if (isUsingPointer) {
        document.body.classList.add(IS_USING_POINTER_CLASS)
      } else {
        document.body.classList.remove(IS_USING_POINTER_CLASS)
      }
    }
  }
}
